import React from 'react'
import { t } from 'ttag'

import { DetailsCard } from 'components/shared/DetailsCard/DetailsCard'

export const DefaultDescription = () => (
  <React.Fragment>
    <DetailsCard.Text>{t`Prioritise the outcomes that matter most for this role and your organisation.`}</DetailsCard.Text>
    <DetailsCard.Text>{t`Note that prioritising one outcome will influence the others - if no priority is set, all factors are weighted equally.`}</DetailsCard.Text>
  </React.Fragment>
)
